import { render, staticRenderFns } from "./AdminSupport.vue?vue&type=template&id=0fd93d00&"
import script from "./AdminSupport.vue?vue&type=script&lang=js&"
export * from "./AdminSupport.vue?vue&type=script&lang=js&"
import style0 from "./AdminSupport.vue?vue&type=style&index=0&id=0fd93d00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports